import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/index';

@Component({
    selector: 'installationanilox',
    templateUrl: './anilox.component.html',
    standalone: false
})
export class InstallationAniloxPluginComponent {
  public config: any;
  public anilox: any[];
  public editRoute = ['installation', 'anilox', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.anilox = this.config.Anilox;
  }
}
PluginComponent.plugins['installationanilox'] = InstallationAniloxPluginComponent;
